module.exports = __webpack_public_path__ + "static/img/cider_logo.8203bf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cider_logo.png
// module id = 292
// module chunks = 1